$('#partialUserResetForm').on('ajaxUpdate', function (event, context, data, statusText, jqXHR) {
    if (context.handler === 'resetPassword::onResetPassword' &&
        data.hasOwnProperty('resetPassword::complete') &&
        data['resetPassword::complete'].indexOf('Password reset complete') !== -1 ) {
        $(event.target).append('<p>You will be redirecting to the Sing in page within 5 seconds.</p>')

        setTimeout(function () { window.location.href = '/login'; }, 5000);
    }
});
